module.exports = __webpack_public_path__ + "fonts/Inter-VariableFont_slnt,wght.0c819cf9.ttf";